export const getTaskActionsColor = (item: string) => {
    const colorMap: { [key: string]: string } = {
        mailing: 'warning',
        information: 'error',
        documentation: 'blue',
        whatsapp: 'success',
        pending: 'purple',
        'visit-update': 'pink',
        'no-visit': 'pink',
        visit: 'pink',
        sold: 'teal',
        recall: 'cyan',
        calling: 'yellow',
        rsi: 'lime',
        duplicated: 'orange',
        rejected: 'error',
        call: 'cyan',
        aiCall: 'pink',
        appointment: 'warning',
        whatsappAppointment: 'success',
        whatsappDocumentation: 'success',
        whatsappLocation: 'success',
        'follow-up': 'orange',
        'presentation-card': 'darkTeal',
    };

    return colorMap[item] || 'secondary';
};
